import React from "react";
import { useSelector } from "react-redux";

import Navbar from "./navbar";
import Draw from "./draw";
import Dialog from "./dialog";
import Paypal from "./paypal.js";

export default () => {
    return (
        <div>
            <Navbar title="Coloriage / Quadrillage" />
            <div className="container">
                <Draw />
            </div>
            <Dialog />
            <Paypal />
        </div>
    );
};
